/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCreativeCommonsZero = createReactComponent(
  "creative-commons-zero",
  "IconCreativeCommonsZero",
  [
    ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
    ["path", { d: "M12 12m-3 0a3 4 0 1 0 6 0a3 4 0 1 0 -6 0", key: "svg-1" }],
    ["path", { d: "M14 9l-4 6", key: "svg-2" }]
  ]
);

export { IconCreativeCommonsZero as default };
//# sourceMappingURL=IconCreativeCommonsZero.js.map
